import React from "react";
import "./CoreValueSection.css";

const CoreValueSection = () => {
  return (
    <section className="cvp-bg-section">
      <div className="cvp-bg-content">
        <p className="cvp-bg-subtitle">WHO WE ARE</p>

        <h2 className="cvp-bg-title">Core Value Proposition</h2>

        <h3 className="cvp-bg-headline">
          Synergy. Innovation. Foundational Excellence.
        </h3>

        <p className="cvp-bg-description">
          The strength of the CM Group of Companies lies in our integrated
          vision. We connect pioneering sectors, leveraging expertise in
          essential fields like green energy and strategic real estate to
          create comprehensive solutions. We provide more than services; we
          deliver the robust, sustainable foundation necessary for complex
          challenges and exceptional, enduring success.
        </p>
      </div>
    </section>
  );
};

export default CoreValueSection;
